import { Button } from "@components/ui/button";
import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { Control } from "react-hook-form";
import DragChild from "./DragChild";

import { BlockQuoteIcon, DescriptionIcon, ImageIcon } from "@assets/icons";
import { useState } from "react";

type DragTestProps = {
  control: Control<any>;
  remove: (index: number) => void;
  fields: Array<any>;
  append: (value: any) => void;
  move: (from: number, to: number) => void;
  getValues?: any;
  setValue: any;
  watch: any;
};

const DragTEst: React.FC<DragTestProps> = ({
  control,
  fields,
  append,
  remove,
  move,
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  //   const items = watch("items");

  // Drag end handler for dnd-kit

  function handleDragEnd(event: any) {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = fields.findIndex((item) => item.id === active.id);
      const newIndex = fields.findIndex((item) => item.id === over.id);
      if (oldIndex !== -1 && newIndex !== -1) {
        // Update react-hook-form field array ordering using move
        move(oldIndex, newIndex);
      }
    }
    setIsDragActive(false);
  }

  const [isDragActive, setIsDragActive] = useState<boolean>(false);

  return (
    <div>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        onDragMove={() => setIsDragActive(true)}
        onDragStart={() => setIsDragActive(true)}
        onDragCancel={() => setIsDragActive(false)}
      >
        <SortableContext items={fields} strategy={verticalListSortingStrategy}>
          {fields.map((field, index) => (
            <div key={field.id} className="mb-4">
              <DragChild
                field={field}
                control={control}
                remove={remove}
                id={index}
                key={field.id}
                isDragActive={isDragActive}
              />
            </div>
          ))}
        </SortableContext>
      </DndContext>
      <div className="flex justify-center items-center">
        <div className="flex gap-[20px] px-[20px] py-[10px] p-2 rounded-md border w-fit  my-10 justify-center items-center shadow-sm">
          <blockquote className="text-[#1DA077] font-medium">
            Add More
          </blockquote>
          <Button
            variant={"outline"}
            type="button"
            title="Add Image"
            onClick={(e) => {
              e.stopPropagation();
              append({
                id: fields.length + 1, // Ensure unique ID
                type: "image",
                image: "",
                label: "",
              });
            }}
          >
            {/* <Tooltip description="Add Image"> */}
            <ImageIcon />
            {/* </Tooltip> */}
          </Button>
          <Button
            variant={"outline"}
            type="button"
            className="block"
            title="Add Description"
            onClick={(e) => {
              e.stopPropagation();
              append({
                id: fields.length + 1, // Ensure unique ID
                type: "description",
                question: "",
                answer: "",
              });
            }}
          >
            {/* <Tooltip description="Add Description"> */}
            <DescriptionIcon />
            {/* </Tooltip> */}
          </Button>

          <Button
            variant={"outline"}
            type="button"
            className="block"
            title="Add Quotation"
            onClick={(e) => {
              e.stopPropagation();
              append({
                id: fields.length + 1, // Ensure unique ID
                type: "quotation",
                description: "",
              });
            }}
          >
            {/* <Tooltip description="Add Quotation"> */}
            <BlockQuoteIcon />
            {/* </Tooltip> */}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DragTEst;
